import React, { Fragment } from 'react';

const renderSwitch = property => {
  switch (property) {
    case 'body':
      return t('questions.question.email_composition.body');
    case 'subject':
      return t('questions.question.email_practice.subject');
    case 'from':
      return t('questions.question.email_reply.from');
    case 'message':
      return t('questions.question.email_reply.message');
    default:
      return property + ':';
  }
};

const QuestionDetails = ({ questionType, details }) => {
  return (
    <>
      {questionType && (
        <div className="fw-b d-ib mt-8 mb-8 fz-bigger">
          {t(`questions.question.${questionType}.display_header`)}
        </div>
      )}
      <div>
        {Object.entries(details).map(([property, value]) => (
          <Fragment key={property}>
            <p className="fw-b mb-0">{renderSwitch(property)}</p>
            <p className="ws-pl">{value}</p>
          </Fragment>
        ))}
      </div>
    </>
  );
};

export default QuestionDetails;
